module.exports = __webpack_public_path__ + "Vue/Common/Content/loader.gif";